import React from "react";
import "../../Assets/Styles/Style.css";
const Transactions = ({ data }) => (
  <div className="transaction-container">
    {data?.transactions
      .slice()
      .reverse()
      .map((transaction, index) => (
        <div key={index} className="transaction-item">
          <div className="transaction-info">
            <div className="transaction-text">
              <p className="transaction-description">
              {transaction?.description || "Null"} (V.
                {transaction?.voucher || "Null"})
              </p>
              <p className="transaction-transaction-type">
                {transaction?.transaction_type_display || "Null"}
              </p>
            </div>
            <div>
              <div className="transaction-text">
                <p className="transaction-amount">
                  ₹ {transaction?.amount || "Null"}
                </p>
                <p className="transaction-date">
                  <strong>{transaction?.transaction_at || "Null"}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
  </div>
);

export default Transactions;
